import styled from "styled-components";

export const DarkBG = styled.div`
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: fixed;
  `;
  
export const Centered = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -40%);
  z-index: 102;
  height: 100%;
  cursor: default;
  @media screen and (max-width: 575px) {
    transform: translate(-50%, -50%);
  }
  @media screen and (max-height: 540px) {
    transform: translate(-50%, -49%);
  }
  @media screen and (max-height: 430px) {
    transform: translate(-50%, -51%);
    height: 100vh;
  }
`;

export const ProfileCentered = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -40%);
  z-index: 102;
  height: 100%;
`;
  
export const TheModal = styled.div`
  width: 500px;
  height: 320px;
  background: #FAFAFA;
  color: white;
  z-index: 10;
  border-radius: 16px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);
  overflow-y: auto;
  @media screen and (max-width: 575px) {
    width: 100vw;
    height: 100%;
    border-radius: 0px;
  }
  @media screen and (max-height: 430px) {
    width: 100%;
    height: 100%;
    border-radius: 0px;
  }
`;

export const ProfileModal = styled.div`
  width: 500px;
  height: 550px;
  background: #FAFAFA;
  color: white;
  z-index: 10;
  border-radius: 16px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);
  overflow-y: auto;
`;
  
export const ModalHeader = styled.div`
    height: 50px;
    background: #FAFAFA;
    overflow: hidden;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    display: flex;
    justify-content: center;
    padding-bottom: 80px;
`;
  
export const Heading = styled.div`
    margin: 0;
    color: #2c3e50;
    font-weight: 500;
    font-size: 18px;
    text-align: center;
    padding-top: 15px;
    padding-bottom: 45px;
    border-bottom: .5px solid;
    border-color: black;
    width: 450px;
    height: 50px;
`;
  
export const ModalContent = styled.div`
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
    color: #2c3e50;
`;
  
export const ModalActions = styled.div` {
    position: absolute;
    bottom: 2px;
    margin-bottom: 10px;
    width: 100%;
`;
  
export const ActionsContainer = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
`;
  
export const CloseButton = styled.div`
    cursor: pointer;
    font-weight: 500;
    padding: 4px 8px;
    border-radius: 0px 16px 0px 0px;
    border: none;
    font-size: 18px;
    color: #2c3e50;
    background: white;
    transition: all 0.25s ease;
    position: absolute;
    right: 0;
    top: 0;
    align-self: flex-end;
    &:hover {
      background: gray;
    }
`;

export const SubmitButton = styled.div`
    cursor: pointer;
    font-weight: 500;
    padding: 11px 28px;
    border-radius: 10px;
    font-size: 0.8rem;
    border: none;
    color: #fff;
    background: #398DE8;
    transition: all 0.25s ease;
    margin-bottom: 10px;
    margin-top: -5px;
    &:hover {
      box-shadow: 0 10px 20px -10px #EAEAEA;
      transform: translateY(-5px);
      background: #6BACF2;
    }
`;
  
export const CancelButton = styled.div`
    margin-top: 10px;
    cursor: pointer;
    font-weight: 500;
    padding: 11px 28px;
    border-radius: 12px;
    font-size: 0.8rem;
    border: none;
    color: #2c3e50;
    background: #fcfcfc;
    transition: all 0.25s ease;
    &:hover {
      box-shadow: none;
      transform: none;
      background: whitesmoke;
    }
`;

export const NotesContainer = styled.div`
    border-color: #E9E9E9;
    border-width: 1px;
    border-style: solid;
    height: 120px;
    border-radius: 5px;
    padding-left: 10px;
    padding-top: 5px;
    margin-bottom: 10px;
`;

export const Tab = styled.button`
    padding-bottom: 20px;
    padding-top: 20px;
    cursor: pointer;
    opacity: 0.6;
    border: 0;
    outline: 0;
    border-bottom: 2px solid transparent;
    transition: ease border-bottom 250ms;
    width: 100px;
    background-color: #FAFAFA;
    border-radius: 7px;
    &:hover {
        transition: all 0.3s ease-in-out;
        background-color: #F0F0F0;
    }
    text-align: center;
    ${({ active }) =>
        active &&
        `
        border-bottom: 2px solid black;
        opacity: 1;
        &:hover {
            transition: all 0.3s ease-in-out;
            background-color: #FAFAFA;
        }
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
        `
    }
`;